/* import __COLOCATED_TEMPLATE__ from './delete-credit-transaction-modal-confirm.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { all, dropTask } from 'ember-concurrency';
import { closeModal } from 'sh-www/utils/modal-controls';
import { handleErrorResponseWithModal } from 'sh-www/utils/handles-errors';

const CLASS_NAME = 'SH-c-reports-delete-credit-transaction-modal-confirm';

class ReportsDeleteCreditTransactionConfirmModal extends Component {
  @service session;
  @service('commands/sh-general-invoice-transaction-commands') shGeneralInvoiceTransactionCommandService;

  get className() {
    return CLASS_NAME;
  }

  get submitDisabled() {
    return this.handleDeleteTransaction.isRunning;
  }

  @dropTask
  *handleDeleteTransaction() {
    const {
      shGeneralInvoiceTransaction,
      loadCompanyCostCodeCreditsTask,
      loadCompanyCreditFactoidsTask,
      loadCreditDeletedInvoicesTask,
      loadCreditUnpaidInvoicesTask,
      updateCompanyCreditFactoids,
      updateCompanyCostCodeCredits,
      updateShGeneralDeletedInvoices,
      updateShGeneralUnpaidInvoices,
    } = this.args.model;

    try {
      // perform deletion
      yield this.shGeneralInvoiceTransactionCommandService.deleteShGeneralInvoiceTransactionTask({
        shGeneralInvoiceTransactionId: shGeneralInvoiceTransaction.id,
      });

      // reload data
      const [
        companyCostCodeCredits,
        creditUnpaidInvoices,
        companyCreditFactoids,
      ] = yield all([
        loadCompanyCostCodeCreditsTask.perform(),
        loadCreditUnpaidInvoicesTask.perform(),
        loadCompanyCreditFactoidsTask.perform(),
      ]);

      // update data
      updateCompanyCostCodeCredits(
        companyCostCodeCredits.costCodes,
        companyCostCodeCredits.costCodesCurrentPage,
      );
      updateShGeneralUnpaidInvoices(
        creditUnpaidInvoices.shGeneralUnpaidInvoices,
        creditUnpaidInvoices.shGeneralUnpaidInvoicesPagination,
      );
      updateCompanyCreditFactoids(companyCreditFactoids);

      // admin only reload and update
      if (this.session.currentUser.isAdmin) {
        const creditDeletedInvoices = yield loadCreditDeletedInvoicesTask.perform();
        updateShGeneralDeletedInvoices(
          creditDeletedInvoices.shGeneralUnpaidInvoices,
          creditDeletedInvoices.shGeneralUnpaidInvoicesPagination,
        );
      }

      closeModal(this);
    } catch (e) {
      handleErrorResponseWithModal(this, e);
    }
  }

  @action
  handleDismiss() {
    closeModal(this);
  }
}

export default ReportsDeleteCreditTransactionConfirmModal;
